import { render, staticRenderFns } from "./editBusinessFunction.vue?vue&type=template&id=58cc156d&scoped=true"
import script from "./editBusinessFunction.vue?vue&type=script&lang=js"
export * from "./editBusinessFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc156d",
  null
  
)

export default component.exports